import { z } from 'zod';
/**
 * Personal API tokens (docs/adr/0088-mcp-server-and-estimates.md). A token acts as its owner in one workspace and works
 * on the MCP route only. It is shown once, when it is made; only a hash is kept.
 */
export const API_TOKEN_PREFIX = 'chp_';
/** The longest a token may live. */
export const API_TOKEN_MAX_DAYS = 365;
export const API_TOKEN_DEFAULT_DAYS = 90;
export const ApiToken = z.object({
    id: z.uuid(),
    name: z.string(),
    /** The first characters after `chp_`, so a person can tell their tokens apart. Never enough to use one. */
    prefix: z.string(),
    expiresAt: z.string(),
    lastUsedAt: z.string().nullable(),
    revokedAt: z.string().nullable(),
    createdAt: z.string(),
});
/**
 * Who may make tokens in a workspace (docs/adr/0098): `admins` = owners and admins, `staff` = owners, admins and
 * members. Guests never.
 */
export const McpTokenCreators = z.enum(['admins', 'staff']);
export const ApiTokenList = z.object({
    items: z.array(ApiToken),
    /** Whether the caller may make a token now (the workspace's "Who can make tokens", docs/adr/0098). */
    canCreate: z.boolean(),
});
export const CreateApiTokenInput = z.object({
    name: z.string().trim().min(1).max(80),
    days: z.number().int().min(1).max(API_TOKEN_MAX_DAYS).default(API_TOKEN_DEFAULT_DAYS),
});
/**
 * A token as workspace owners and admins see it in Settings → Connectors (docs/adr/0098): whose it is, never the secret
 * or its hash.
 */
export const WorkspaceApiToken = ApiToken.extend({ owner: z.object({ id: z.uuid(), name: z.string() }) });
export const WorkspaceApiTokenList = z.object({ items: z.array(WorkspaceApiToken) });
/** The only time the token itself is returned. */
export const CreatedApiToken = z.object({ token: z.string(), item: ApiToken });
/** True for a string shaped like one of our tokens (the guard sends only these to the token check). */
export const looksLikeApiToken = (s) => /^chp_[A-Za-z0-9_-]{43}$/.test(s);
//# sourceMappingURL=api-tokens.js.map